import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=5b198320&"
import script from "./Success.vue?vue&type=script&lang=js&"
export * from "./Success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports